/** Days after today in the day strip of the management views (administrative booking, all bookings). */
export const MANAGEMENT_DAYS_AHEAD = 30
